import React, { useEffect, useState } from 'react';
import { getIn18Text, apiHolder, emailPattern, apis } from 'api';
import { Button, Input } from '@lingxi-common-component/sirius-ui';
import styles from './SubAccEntryGuide.module.scss';
import Crystal from '@web/images/icons/mail/crystal.png';
import { navigate } from 'gatsby';
import { SiriusHtmlModal } from '@web-common/components/UI/SiriusModal';
import { getBindEmailMessage } from '@web-common/components/UI/MultAccountsLoginModal/data';
import Icon from '@web-mail/common/components/Icon';
const eventApi = apiHolder.api.getEventApi();
const trackApi = apiHolder.api.requireLogicalApi(apis.dataTrackerApiImp);
const SubAccEntryGuide = props => {
    const { visible, setVisible } = props;
    const [email, setEmail] = useState('');
    const [errMsg, setErrMsg] = useState('');
    const enterEmail = (e) => {
        var _a;
        setEmail(((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value) || '');
    };
    const addImmediately = async () => {
        trackApi.track('pc_mail_addEmail_window', { action: 'subimt' });
        setErrMsg('');
        if (!email) {
            setErrMsg(getIn18Text('QINGSHURUYOUXIANGZHANG'));
            return;
        }
        if (!emailPattern.test(email.trim())) {
            setErrMsg(getIn18Text('YOUXIANGZHANGHAOGESYW'));
            return;
        }
        const errorMessage = await getBindEmailMessage(email);
        if (errorMessage) {
            setErrMsg(errorMessage);
            return;
        }
        navigate('/#mailbox');
        eventApi.sendSysEvent({
            eventName: 'toAddAccount',
            eventStrData: '',
            eventData: {
                email: email.trim(),
                purpose: 'intoStep2',
            },
        });
        setVisible(false);
    };
    const reBindAccount = () => {
        navigate('/#mailbox');
        eventApi.sendSysEvent({
            eventName: 'toAddAccount',
            eventStrData: '',
            eventData: {
                email: email.trim(),
                purpose: 'reBind',
            },
        });
        setVisible(false);
    };
    const cancel = () => {
        setVisible(false);
    };
    useEffect(() => {
        if (visible)
            trackApi.track('pc_mail_addEmail_window', { view: true });
    }, [visible]);
    return (React.createElement(SiriusHtmlModal, { width: 480, visible: visible, closable: false },
        React.createElement("div", { className: styles.subAccEntryGuide },
            React.createElement("div", { className: styles.header },
                React.createElement("img", { className: styles.crystal, src: Crystal }),
                React.createElement("div", { className: styles.title },
                    React.createElement("p", null, getIn18Text('TIANJIANINDGZYX')),
                    React.createElement("p", null,
                        getIn18Text('TIYAN'),
                        React.createElement("span", null,
                            React.createElement("span", null, getIn18Text('GAOXIAOYOUJGLGJ'))))),
                React.createElement("div", { className: styles.features },
                    React.createElement("div", { className: styles.feature }, getIn18Text('WAIMAORENZSGZLAXX')),
                    React.createElement("div", { className: styles.feature }, getIn18Text('LIANXIRENWLYJZLHZJ')),
                    React.createElement("div", { className: styles.feature }, getIn18Text('KEHUSHUJCDGJTX')),
                    React.createElement("div", { className: styles.feature }, getIn18Text('SHOUJIDUANSSCLZYYJ')))),
            React.createElement("div", { className: styles.contArea },
                React.createElement("div", { className: styles.enterArea },
                    React.createElement("p", null,
                        getIn18Text('TIANJIAYOUXIANG'),
                        "\uFF1A"),
                    React.createElement(Input, { className: styles.enterAccount, placeholder: getIn18Text('QINGSHURUNDGZYX'), value: email, onChange: e => enterEmail(e) }),
                    errMsg ? (React.createElement("div", { className: styles.errorArea },
                        React.createElement("p", { className: styles.errorMsg },
                            React.createElement(Icon, { type: "info" }),
                            errMsg,
                            errMsg === getIn18Text('BIND_SUBACCOUNT_EXPIRED') ? (React.createElement("span", { className: styles.blue, onClick: reBindAccount }, getIn18Text('recheck'))) : (React.createElement(React.Fragment, null))))) : (React.createElement(React.Fragment, null))),
                React.createElement(Button, { className: styles.addImmediately, onClick: addImmediately }, getIn18Text('LIJITIANJIA')),
                React.createElement(Button, { className: styles.cancel, onClick: cancel }, getIn18Text('QUXIAO'))))));
};
export default SubAccEntryGuide;
